import { SText } from '@setvi/shared/components';

interface BooleanValueProps {
  value: boolean;
}

export const BooleanValue = ({ value }: BooleanValueProps) => (
  <SText weight="bold" title={value ? 'Yes' : 'No'} />
);
